<div #layoutHeader class="row layout-header" [class.layout-header--stuck]="isHeaderStuck">
  <div class="col-12">
    <app-menu [isNavBarOpen]="isNavBarOpen"></app-menu>
  </div>
</div>
<div class="row">
  <div
    class="col-12"
    [class.layout-outlet-clearance]="needsFooterBottomClearance"
  >
    <router-outlet></router-outlet>
</div>
</div>
<div class="row">
  <div class="col-12">
    <app-footer></app-footer>
  </div>
</div>
 

